import { Box, Stack } from '@ff-it/ui';
import { ReactElement } from 'react';
import type { RadioTimeBands } from '../types';
import { AddInline, FormInlineError, Inlines } from 'components';
import type { Outlet } from 'modules/supplier/outletOrServiceCategory/types';
import { RateCardEdit } from './RateCard';
import type { RateCard } from '../types/pricelist';
import { BoolIcon } from 'components/Icon';
import { BandRateTable } from '../common/BandRateTable';
import { getRateCardName } from '../common/util';

const initialRateValues = (idx: number) => ({
  name: '',
  default: idx === 1,
  rates: {},
  __NEW__: Date.now(),
});

type RateCardProps = { outlets: Outlet[]; bands: RadioTimeBands };

/** Bands and outlets are gated by the price-list screen — this card is not
 * rendered until both exist. */
export function EditRateCards({ outlets, bands }: RateCardProps): ReactElement {
  return (
    <Box>
      <FormInlineError name="ratecards" className="mb-1" />
      <Stack direction="vertical" mb="1">
        <Inlines name="ratecards">
          {({ name, index }) => <RateCardEdit name={name} index={index} bands={bands} outlets={outlets} />}
        </Inlines>
      </Stack>
      <AddInline name="ratecards" initialValues={initialRateValues}>
        Add ratecard
      </AddInline>
    </Box>
  );
}

export function ViewRateCards({ outlets, bands, ratecards }: RateCardProps & { ratecards: RateCard[] }): ReactElement {
  return (
    <Stack direction="vertical">
      {ratecards.map((ratecard) => (
        <Box key={ratecard.id}>
          <Stack direction="horizontal" py="2">
            <Box fontSize="sm" fontWeight="semibold" color="gray700">
              {getRateCardName(ratecard)}
            </Box>
            <Box ml="auto">
              <BoolIcon>{ratecard.default}</BoolIcon> Default ratecard
            </Box>
          </Stack>
          <BandRateTable
            bands={bands}
            columns={outlets.map(({ id, name }) => ({
              key: id,
              header: name,
              render: (_band, _dayType, bandKey) => ratecard.rates[bandKey]?.[`_${id}`],
            }))}
          />
        </Box>
      ))}
    </Stack>
  );
}
